import CompanyWorkSchedule from "./company-work-schedule";
import UserWorkSchedule from "./user-work-schedule";
import DatetimeUtils from "../../utils/datetime-utils";

export default class WorkSchedule {

    public companyWorkSchedule  : any
    public _users  : { [key: ID]: UserWorkSchedule }  = {}

    constructor() {
        this.updateCompanyWorkSchedule();

        gd.bus.subscribe('gd.session.events:change', this, this.onEventsChange);
        gd.modelBus.subscribe('event', this, this.onEventsChange);
    }

    updateCompanyWorkSchedule = () => {
        this.companyWorkSchedule = new CompanyWorkSchedule(gd.session.events.companyEvents);
        this._users = {};
    }

    onEventsChange = () => {
        this.companyWorkSchedule.updateEvents(gd.session.events.companyEvents);
        _.forEach(this._users, (userWorkSchedule, userId) => {
            const userEvents = _.filter(gd.session.events.personalEvents, event=>event.userId === userId);
            userWorkSchedule.updateEvents(userEvents);
        })
    }

    isWorkingDay(moment:Moment) {
        return this.companyWorkSchedule.isWorkingDay(DatetimeUtils.momentToDate(moment)) === true;
    }

    getCompanyWorkSchedule() {
        return this.companyWorkSchedule;
    }

    getUserWorkSchedule(userId:ID) {
        if (!this._users[userId]) {
            const userEvents = _.filter(gd.session.events.personalEvents, event=>event.userId === userId);
            this._users[userId] = new UserWorkSchedule(userId, this.companyWorkSchedule, userEvents);
        }

        this._users[userId].updateWorkdayDurations()

        return this._users[userId];
    }
}
